import { Component, Input } from '@angular/core';
import {
  AppIcon,
  AppIconColor,
  AppIconSize,
  FrontendIconsModule,
} from '@tablesready/frontend-icons';

import { NgIf } from '@angular/common';
import { PipesModule } from '@tablesready/common-ui';
import { FloorPlanPartyType } from '../get-party-type';

@Component({
  selector: 'tablesready-table-time',
  templateUrl: './table-time.component.html',
  styleUrls: ['./table-time.component.scss'],
  standalone: true,
  imports: [
    FrontendIconsModule,
    NgIf,
    PipesModule,
  ],
})
export class TableTimeComponent {
  @Input() type = FloorPlanPartyType.booked;
  @Input() quotedTime = 0;
  @Input() seatedTime = 0;
  @Input() checkInTime = 0;
  @Input() canceledTime = 0;
  @Input() duration = 0;
  @Input() colorClass = 'time-light';
  @Input() iconColor = AppIconColor.primary;
  @Input() timezone = '';

  icon = AppIcon;
  size = AppIconSize;
  floorPlanPartyType = FloorPlanPartyType;
}
